<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询：
            </el-button>
          </el-col>
          <el-col
            :xs="8"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
          >
            <el-input
              v-model="masterList.tableQuery.search.materialsName"
              placeholder="请输入物料名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col
            :xs="8"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
          >
            <el-input
              v-model="masterList.tableQuery.search.schemeNo"
              placeholder="请输入方案编号"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col
            :xs="12"
            :sm="8"
            :md="6"
            :lg="4"
            :xl="3"
          >
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @export="batchExport(masterList)"
      />
    </div>
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 导出batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 权限验证
import checkPermission from '@/utils/permission'
// 数据请求
import { loadOutdepotBillDetailListDataApi, loadOutdepotBillDetailExportDataApi } from '@/api/outdepotBill'

export default {
  name: 'OutdepotDetail',
  components: {
    CustomTable,
    TableOperation
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'outdepot_detail_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['outdepot_detail_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: '', // 排序字段
            order: '' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            name: '',
            noViewSmoke: 0
          }
        },
        notPaging: true
      },
      id: null, // 选中的单据ID
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'outdepotId', label: '出库单编号', filterColumn: 'bill.id', width: 120 },
      { prop: 'depotName', label: '仓库名称', filterColumn: 'bill.depot_name', width: 120 },
      { prop: 'outdepotDateStr', label: '出库日期', filterColumn: 'bill.outdepot_date', width: 120, isBetween: true },
      { prop: 'outdepotTypeStr', label: '出库类型', filterColumn: '(case bill.outdepot_type when 1 then \'终端维护\' when 2 then \'其他\' when 3 then \'品牌推广\' when 4 then \'本香\' when 5 then \'渠道营销\' when 6 then \'退库\' else \'\' end)', width: 110 },
      { prop: 'schemeName', label: '方案名称', filterColumn: 'ifnull(tms.name, \'\')', width: 200 },
      { prop: 'schemeNo', label: '方案编号', filterColumn: 'ifnull(tms.project_no, \'\')', width: 200 },
      { prop: 'operater', label: '经办人', filterColumn: 'bill.operater', width: 120 },
      { prop: 'receiver', label: '物料使用人', filterColumn: 'bill.receiver', width: 120 },
      { prop: 'materialsName', label: '物料名称', filterColumn: 'd.materials_name', width: 200 },
      { prop: 'sourceTypeStr', label: '物料来源', filterColumn: '(case d.source_type when 1 then \'自制\' when 2 then \'中心配送\' when 13 then \'调拨出库\' when 21 then \'转固定资产\' else \'\' end)', width: 110 },
      { prop: 'unitName', label: '物料单位', filterColumn: 'd.unit_name', width: 110 },
      { prop: 'specification', label: '规格', filterColumn: 'c.specification', width: 100 },
      // { prop: 'price', label: '最小单位单价', filterColumn: 'd.price', width: 130, isBetween: true },
      { prop: 'amount', label: '出库数量', filterColumn: 'd.amount', width: 120, isBetween: true },
      { prop: 'remark', label: '备注', filterColumn: 'bill.remark', width: 150 },
      { prop: 'operatorName', label: '操作人', filterColumn: 'bill.operator_name', width: 120 },
      { prop: 'operationTimeStr', label: '操作时间', filterColumn: 'bill.operation_time', width: 150, isBetween: true }
    ]
    let noViewSmoke = 1
    if (checkPermission(['sample_smoke_view'])) {
      noViewSmoke = 0
    }
    this.masterList.tableQuery.search.noViewSmoke = noViewSmoke
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.masterList.tableLoading = false
      let pageCondition = { condition: JSON.stringify(this.masterList.tableQuery) }
      loadOutdepotBillDetailListDataApi(pageCondition).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal
      }).catch()
    },
    // 导出数据API
    ExportByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportObj) }
      loadOutdepotBillDetailExportDataApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
